export const reportNameToTableHeaderMap = {
  churn: {
    total: 'Customers',
    actual: 'Cancellations',
    rateMonthly: {
      tableHeader: 'Churn rate',
      commonLabel: 'Churn rate (monthly)'
    },
    rateAnnual: {
      tableHeader: 'Churn rate',
      commonLabel: 'Churn rate (annual)'
    }
  },
  renewals: {
    total: 'Renewal opportunities',
    actual: 'Renewals',
    rateMonthly: {
      tableHeader: 'Renewal rate',
      commonLabel: 'Renewal rate (monthly)'
    },
    rateAnnual: {
      tableHeader: 'Renewal rate',
      commonLabel: 'Renewal rate (annual)'
    }
  }
};